import * as z from 'zod';

export const dependentsSchema = z.object({
  name: z.optional(z.string().min(1, { message: 'Campo obrigatório' })),
  birthDate: z.optional(
    z
      .string()
      .min(1, { message: 'Campo obrigatório' })
      .regex(/^(\d{2})\/(\d{2})\/(\d{4})$/, { message: 'Data inválida' }),
  ),
  civilStatus: z.optional(z.string().min(1, { message: 'Campo obrigatório' })),
  gender: z.optional(z.string().min(1, { message: 'Campo obrigatório' })),
  parentage: z.optional(z.string().min(1, { message: 'Campo obrigatório' })),
  cpf: z.optional(z.string()),
  cns: z.optional(z.string() /* .min(0, { message: 'Campo obrigatório' }) */),
  mothersName: z.optional(z.string().min(1, { message: 'Campo obrigatório' })),
});
